import searchSamplesFacetsConfig from './search-samples-facets.config';

export default {
  title: 'Ejemplares',
  searchId: 'sample',
  searchConfig: searchSamplesFacetsConfig,
  resourcePath: '/samples',
  facetsTitle: 'search#facets_title',
  totalResultsText: 'search#samples_total',
  filtersTitle: 'search#filters_title',
  sort: {
    label: 'search#sort_title',
    options: [
      // {
      //   value: '_score',
      //   label: 'search#sort_score',
      //   selected: false,
      //   disabled: true
      // },
      {
        value: 'slug.keyword_ASC',
        label: 'search#sort_asc',
        selected: true
      },
      {
        value: 'slug.keyword_DESC',
        label: 'search#sort_desc',
        selected: false
      }
    ]
  },
  pagination: {
    limit: 5,
    options: [
      12,
      24,
      48
    ]
  },
  itemPreview: {
    classes: 'is-vertical'
  },
  fallback: {
    text: 'search#fallback_text',
    button: 'search#fallback_button'
  },
  ko: {
    text: 'search#ko_text',
    button: 'search#ko_button'
  }
};
